import { FC } from 'react';
import { v4 as uuid } from 'uuid';
import { ICategoryList } from '../../../../types/category';

interface ITabsCategories {
  categoryList?: ICategoryList;
  selectId: number;
  handleChangSelectId: (id: number) => void;
}
const TabsCategories: FC<ITabsCategories> = ({ categoryList, handleChangSelectId, selectId }: ITabsCategories) => {
  const changeId = (id: number) => {
    if (id) {
      handleChangSelectId(id);
    }
  };
  const generateTabs = (list: ICategoryList) => {
    return list.map(item => {
      if (item.id !== 2) {
        return (
          <div
            key={uuid()}
            onClick={() => {
              if (item.id) {
                changeId(item.id);
              }
            }}
            className={selectId === item.id ? 'selectItemHeader' : 'itemHeader'}
          >
            <div className="containerText">{item.name}</div>
          </div>
        );
      } else {
        return null;
      }
    });
  };
  return (
    <div className="generalTabsContainer">
      <div className="headerTabs">{categoryList && categoryList.length > 0 && generateTabs(categoryList)}</div>
    </div>
  );
};
export default TabsCategories;
